import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default () => {

    const navigate = useNavigate()

    useEffect(() => {
        sessionStorage.clear()
        String(window.location.href).includes('?') && String(window.location.href).split('?')[1].split('&').forEach(arg => sessionStorage.setItem(...arg.split('=')))
        let path = String(window.location.href).split('/')
        navigate('/dashboard/' + path[3].split('?')[0])
    }, [])

    return (
        <></>
    )
}